var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C15.9994 20.5521 15.5521 20.9994 15 21H6C5.44794 20.9994 5.00055 20.5521 5 20V4C5.00055 3.44794 5.44794 3.00055 6 3H15C15.5521 3.00055 15.9994 3.44794 16 4V5C16 5.27614 15.7761 5.5 15.5 5.5C15.2239 5.5 15 5.27614 15 5V4H6V20H15V19C15 18.7239 15.2239 18.5 15.5 18.5C15.7761 18.5 16 18.7239 16 19V20ZM16.6465 14.9395C16.4513 15.1347 16.4513 15.4513 16.6465 15.6465C16.8417 15.8417 17.1583 15.8417 17.3535 15.6465L20.6464 12.3536C20.8417 12.1583 20.8417 11.8417 20.6464 11.6464L17.3535 8.3535C17.1583 8.15827 16.8417 8.15827 16.6465 8.3535C16.4513 8.54873 16.4513 8.86527 16.6465 9.0605L19.086 11.5H10.5C10.2239 11.5 10 11.7239 10 12C10 12.2761 10.2239 12.5 10.5 12.5H19.086L16.6465 14.9395Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a249a27da8cf8c94eeca0bb399c2a622.svg";
export { ForwardRef as ReactComponent };